import React, { Component, Fragment } from 'react';

import ModalDetailsStoreLocation from '../../../../NewHeader/Header/ModalStoreLocation/ModalDetailsStoreLocation';
import ModalStoreLocation from '../../../../NewHeader/Header/ModalStoreLocation/ModalStoreLocation';
import ModalAllStates from '../../../../NewHeader/Header/ModalStoreLocation/ModalAllStates';
import StoreLocationBtn from '../../../../NewHeader/Header/StoreLocationBtn';
import NewDropDown from '../../../../NewHeader/Header/NewHeaderWeb/NewDropdown';
import Overlay from '../../../../NewHeader/Header/Overlay';

import commonUtil from '../../../../../utils/commonUtil';
import { mapMarkerIcon } from '../../../../NewHeader/Header/svgIcons';

const constChannels = commonUtil.getClientConstForChannel();
const channel = commonUtil.getChannel();
class NewHeaderTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aboveServicesButton: false,
      aboveOtherSitesButton: false,

      shouldShowModalDetails: {
        storeName: '',
        schedule: '',
        address: {},
        storeId: '',
        services: '',
      },
    };
  }

  handleOnHoverServicesBtn = statusHover => this.setState({ aboveServicesButton: statusHover });

  handleOnHoverOtherSitesBtn = statusHover => this.setState({ aboveOtherSitesButton: statusHover });

  handleModalDetails = ({ storeName, address, storeId, services, schedule }) => {
    this.setState({ ...this.state, shouldShowModalDetails: { storeName, address, storeId, services, schedule } });
  }

  render() {
    // * From HeaderTopContainer
    const {
      showModalLocationContent,
      showModalLocationContentUpdate,
      showModalStates,
      showModalStatesUpdate,
      showModalDetails,
      showModalDetailsUpdate,

      storesForZip,
      storesForState,
      storeOrCityOrStateName,

      // * Functions
      hideOverlay,
      callForSearchStores,
      callSearchZipStateService,
      stateOrZipSelectedUpdate,
    } = this.props;

    // * From Header container
    const {
      home,
      services,
      linksHeaderTop,
      otherSites,
      storeLocationStates,
      storeByNear,
      requiredLabel,
      storeNearSelected,
    } = this.props;

    const { links: itemsHeaderTop } = linksHeaderTop || {};
    const getAllStatesOfCountry = storeLocationStates.data;

    const { aboveServicesButton, aboveOtherSitesButton, shouldShowModalDetails } = this.state;

    return (
      <div className="wrapHeaderTop" id='header_web_gap'>
        <div className="headerTopContainer centerHeader">
          <section className="borderRight" style={{ display: 'none' }}>
            <div className="itemLink">
              {mapMarkerIcon}
              <a
                className="item rightTopMenu"
                href="https://dtaqa.suburbia.com.mx/tienda/home"
              >
                Mi direccion
              </a>
            </div>
            <div className="itemLink">
              <a
                className="item rightTopMenu regularFont"
                href="https://dtaqa.potterybarn.com.mx/tienda/home"
              >
                C.P. 03840
              </a>
            </div>
          </section>

          <StoreLocationBtn
            showModalLocationContentUpdate={showModalLocationContentUpdate}
            storeNearSelected={storeNearSelected}
          />

          {
            channel === constChannels.WEB && (
              <Fragment>
                <div
                  className="itemLink headerTopRightSection dinamicItemContainerForDropdown"
                >
                  <div className="dropdownsHeaderTopContainer">
                    <span
                      className="item dropdownHeaderTopBtn dropdownServicesWidthBtn"
                      style={{ color: '#FAFAFA', cursor: 'pointer' }}
                      onMouseEnter={() => this.handleOnHoverServicesBtn(true)}
                      onMouseLeave={() => this.handleOnHoverServicesBtn(false)}
                    >
                      {itemsHeaderTop[0].label}
                    </span>
                    <span className="chevron bottom" />
                  </div>
                  { aboveServicesButton &&
                    <NewDropDown
                      handleOnHoverBtn={this.handleOnHoverServicesBtn}
                      aboveServicesButton={aboveServicesButton}
                      dataList={services}
                    />
                  }
                </div>

                <div
                  className="itemLink dinamicItemContainerForDropdown"
                  style={{ borderRight: '1px solid white' }}
                >
                  <div className="dropdownsHeaderTopContainer">
                    <span
                      className="item dropdownHeaderTopBtn dropdownOtherSitesWidthBtn"
                      onMouseEnter={() => this.handleOnHoverOtherSitesBtn(true)}
                      onMouseLeave={() => this.handleOnHoverOtherSitesBtn(false)}
                      style={{ minWidth: '100px', color: '#FAFAFA', cursor: 'pointer' }}
                    >
                      {itemsHeaderTop[1].label}
                    </span>
                    <span className="chevron bottom" />
                  </div>
                  { aboveOtherSitesButton &&
                    <NewDropDown
                      handleOnHoverBtn={this.handleOnHoverOtherSitesBtn}
                      aboveOtherSitesButton={aboveOtherSitesButton}
                      dataList={otherSites}
                    />
                  }
                </div>

                <div
                  className="itemLink"
                  style={{
                    borderRight: '1px solid white',
                    position: 'relative',
                    fontFamily: 'robotoMedium',
                  }}
                >
                  <a className="item" href="/">{itemsHeaderTop[2].label}</a>
                  {/* <span className="decoratorUndeline" /> */}
                </div>

                {/* <div className="itemLink">
                  <a className="item" href={commonUtil.getLabel(home, 'home.menu.credito.micredito')}>{itemsHeaderTop[3].label}</a>
                </div> */}
              </Fragment>
            )
          }
        </div>

        { (aboveServicesButton || aboveOtherSitesButton || showModalLocationContent) && (
          <Overlay
            styles={{
              styleTop: `${showModalLocationContent ? 0 : '40px'}`,
              cursor: `${showModalLocationContent ? 'default' : 'cursor'}`,
              zIndex: 1,
            }}
          >
            <Fragment>
              {
                showModalLocationContent && !showModalStates && !showModalDetails && (
                  <ModalStoreLocation
                    hideOverlay={hideOverlay}
                    showModalStatesUpdate={showModalStatesUpdate}
                    showModalDetailsUpdate={showModalDetailsUpdate}
                    showModalLocationContent={showModalLocationContent}

                    storeLocationStates={storeLocationStates}
                    storeNearSelected={storeNearSelected}
                    callForSearchStores={callForSearchStores}
                    callSearchZipStateService={callSearchZipStateService}
                    storesForZip={storesForZip}
                    storesForState={storesForState}

                    // * For ModalAllStates functionality
                    stateSelected={storeOrCityOrStateName.stateSelected}
                    storeByNear={storeByNear}
                    requiredLabel={requiredLabel}

                    // * For modal details
                    handleModalDetails={this.handleModalDetails}
                  />
                )
              }

              {
                showModalStates && (
                  <ModalAllStates
                    withReturn={showModalStatesUpdate}
                    stateOrZipSelectedUpdate={stateOrZipSelectedUpdate}
                    hideOverlay={hideOverlay}
                    data={getAllStatesOfCountry}
                  />
                )
              }

              {
                showModalDetails && (
                  <ModalDetailsStoreLocation
                    withReturn={showModalDetailsUpdate}
                    data={shouldShowModalDetails}
                    hideOverlay={hideOverlay}
                  />
                )
              }
            </Fragment>
          </Overlay>
        )}
      </div>
    );
  }
}

export default NewHeaderTop;
